import React, { useState } from 'react';

import {Items, useFetch} from '@thinkwell/react.common';
const ContentsContext = React.createContext([{}, () => {}, {}, () => {}, () => {}, () => {}]);

const ContentsProvider = (props) => {
  const [items, setItems, upsertItem, getItem, deleteItem] = Items(useState(props && props.value || []))
  const [fetchContentsState, fetchContents] = useFetch({onSuccess: setItems})

  return (
    <ContentsContext.Provider value={[items, fetchContents, fetchContentsState, upsertItem, getItem, deleteItem]}>
      {props.children}
    </ContentsContext.Provider>
  );
};

export { ContentsContext, ContentsProvider}
